import EventComponent from '../components/EventComponent';
import { EVENT_TYPES } from '../types';
export class EventSystem {
    constructor(coreApi) {
        this.coreApi = coreApi;
        EVENT_TYPES.forEach((event) => {
            this.coreApi.subscribe(event, (params) => this.onEvent(event, params));
        });
        this.eventEntity = this.coreApi.getServices().entityManager.createEntity();
    }
    onEvent(event, params) {
        this.eventEntity.addComponent(new EventComponent(event, params));
    }
}
//# sourceMappingURL=EventSystem.js.map